<template>
  <div class="item">
    <a @click="isOpen = true">
      <img :src="person.image" alt="" class="thumbnail">
    </a>
    <p
      class="name"
      @click="isOpen = true"
      style="cursor:pointer;"
    >
      {{ person.title }}
    </p>
    <p class="description">
      {{ person.position }} <!--<br>
      <span v-if="person.id_number">
        (#{{ person.id_number }})
      </span>-->
    </p>
    <button class="button read-more" @click="isOpen = true">
      Read bio <img src="/images/icons/right-main.svg" alt="" />
    </button>
    <app-profile-modal :member="person" :showpopup.sync="isOpen" />
  </div>
</template>

<script>
export default {
  props: {
    person: {
      type: Object,
      required: true,
    },
  },

  data () {
    return {
      isOpen: false,
    }
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/PersonCard.vue